import "./header.css";
import logo from "../../assets/logo.svg";
import Dropdown from 'react-bootstrap/Dropdown';
import {useTranslation} from 'react-i18next';
import {useEffect, useState} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {Link} from "react-router-dom";

function Header() {
    const {i18n} = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState('English');
    const campaignSlug = window.campaign_slug || ''

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const languageMapping = {
        en: "English",
        fr: "Français",
        aue: "لعربية",
        ch: "中文",
        jp: "日本語",
        no: "Español",
        ru: "Русский"
    };

    const changeLanguage = (lng) => {
        if (i18n.language !== lng) {
            i18n.changeLanguage(lng);
            setSelectedLanguage(languageMapping[lng] || 'English');
            window.localStorage.setItem('Localelanguage', lng);
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const lang = params.get('lang') || window.localStorage.getItem('Localelanguage') || 'en';

        if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }

        setSelectedLanguage(languageMapping[lang] || 'English');
        if (campaignSlug === 'DAWUL') {
            i18n.changeLanguage('aue');

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="header">
            <>
                {['xxl'].map((expand) => (
                    <Navbar key={expand} expand={expand}>
                        <Container fluid>
                            {window.location.pathname === "/welcome-to" &&
                                <Navbar.Brand>
                                    <img className="w-12rem" src={logo} alt="logo" width="auto" height="auto"/>
                                </Navbar.Brand>
                            }

                            {window.location.pathname !== "/welcome-to" &&
                                <Navbar.Brand href="/">
                                    <img className="w-12rem" src={logo} alt="logo" width="auto" height="auto"/>
                                </Navbar.Brand>
                            }
                            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`}/>
                            <Navbar.Offcanvas
                                id={`offcanvasNavbar-expand-${expand}`}
                                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                                placement="end"
                            >
                                <Offcanvas.Header closeButton>
                                </Offcanvas.Header>

                                <Offcanvas.Body>
                                    <Nav className="justify-content-end flex-grow-1 gap-4">
                                        <div
                                            className="header_items text-white font-normal uppercase flex align-items-center cursor-pointer text-center text-lg gap-5">
                                            <Link to="/about-us"
                                                  className="no-underline text-white">
                                                About Us
                                            </Link>
                                        </div>

                                        <div
                                            className="header_items text-white font-normal uppercase flex align-items-center cursor-pointer text-center text-lg gap-5">
                                            <span>
                                                <a className="no-underline text-white"
                                                   href="https://www.choicetrade.com/contact-us.php" target="_blank"
                                                   rel="noreferrer">
                                                    Contact Us
                                                </a>
                                            </span>
                                        </div>
                                    </Nav>

                                    <div className="header_lang_item text-white font-normal uppercase text-xl">
                                        <Dropdown>
                                            <Dropdown.Toggle id="dropdown-basic">
                                                {selectedLanguage}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                {Object.keys(languageMapping).map((lng) => (
                                                    <Dropdown.Item key={lng} onClick={() => changeLanguage(lng)}>
                                                        {languageMapping[lng]}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </Offcanvas.Body>
                            </Navbar.Offcanvas>
                        </Container>
                    </Navbar>
                ))}
            </>
        </div>
    );
}

export default Header;